'use client';

import { FC } from 'react';
import { renderAlreadyVotedWarning, renderUnderageWarning } from '~/utils/getVoteWarningMessages';
import { WarningMessagePage } from '~/definitions/warningMessage';

interface Props {
    isDisabledVote?: boolean;
    isUserAlreadyVoted?: boolean;
    isUserChild?: boolean;
    currentPage: WarningMessagePage;
}

const WarningMessage: FC<Props> = (props: Props) => {
    const { isDisabledVote, isUserAlreadyVoted, isUserChild, currentPage } = props;

    if (!isDisabledVote) {
        return null;
    }

    const alreadyVoted = Boolean(isUserAlreadyVoted);
    const isChild = Boolean(isUserChild);
    const warningMessageClassName = 'warning-msg pb-[80px] text-[#df322c] text-center md:text-left px-[15px]';

    return (
        <div className={warningMessageClassName}>
            {renderAlreadyVotedWarning(alreadyVoted, currentPage)}
            {renderUnderageWarning(isChild)}
        </div>
    );
};

export default WarningMessage;
